// Module
var code = "<div class=\"star-rating__stars\">\n  <!-- ko foreach: stars -->\n  <svg-icon params=\"name: 'rating-star-' + $data\" data-bind=\"style: {\n    color: $component.color\n  }\"></svg-icon>\n  <!-- /ko -->\n</div>\n\n<!-- ko if: label -->\n<span class=\"star-rating__label\" data-bind=\"text: label\"></span>\n<!-- /ko -->\n";
// Exports
module.exports = code;